module.exports = "pegasus/assets/hexagon-pinterest.gif";